
import _ from 'lodash'

import http from '../../../../lib/http'
import { notify } from '../../../../lib/Notification/actions.js'
import { map, unmap } from '../../../../lib/Proxy/questionnaire-response.js'

export const GET_ASSESSMENT = 'assessment/GET_ASSESSMENT'
export const GET_ASSESSMENT_SUCCESS = 'assessment/GET_ASSESSMENT_SUCCESS'
export const GET_ASSESSMENT_FAILURE = 'assessment/GET_ASSESSMENT_FAILURE'

export const POST_ASSESSMENT = 'assessment/POST_ASSESSMENT'
export const POST_ASSESSMENT_SUCCESS = 'assessment/POST_ASSESSMENT_SUCCESS'
export const POST_ASSESSMENT_FAILURE = 'assessment/POST_ASSESSMENT_FAILURE'

export const getAssessment =
  (patientId, category, mapping, encounterId) => dispatch => {
    dispatch({
      type: GET_ASSESSMENT,
      category
    })
    const url = encounterId
      ? `/patients/${patientId}/assessments?category=${category}&encounter=${encounterId}&top=1`
      : `/patients/${patientId}/assessments?category=${category}&top=1`
    return http
      .getRequest(url)
      .then(assessmentResponse => {
        const data = unmap(
          _.get(assessmentResponse, 'entry[0].resource', {}),
          mapping
        )
        dispatch({
          type: GET_ASSESSMENT_SUCCESS,
          value: data,
          category
        })
      })
      .catch(error => {
        dispatch({
          type: GET_ASSESSMENT_FAILURE,
          error
        })
        dispatch(notify(`Error Fetching ${category}`), true)
      })
  }

export const createAssessment =
  (formData, patientId, userId, category, encounterId, mapping) =>
    dispatch => {
      dispatch({
        type: POST_ASSESSMENT,
        category
      })
      const questionnaire = map(
        formData,
        patientId,
        userId,
        category,
        encounterId,
        mapping
      )
      return http
        .postRequest(
          `/patients/${patientId}/assessments?category=${category}`,
          questionnaire
        )
        .then(assessmentResponse => {
          const data = unmap(assessmentResponse, mapping)
          dispatch({
            type: POST_ASSESSMENT_SUCCESS,
            value: data,
            category
          })
          dispatch(getAssessment(patientId, category, mapping))
          dispatch(notify(`Successfully Updated ${category}`), false)
        })
        .catch(error => {
          dispatch({
            type: POST_ASSESSMENT_FAILURE,
            error
          })
          dispatch(notify(`Error saving ${category}`), true)
        })
    }
